module.exports = __webpack_public_path__ + "static/media/kirkko-parkkipaikat-small.6cf3fd0f.png";